import React, { useEffect, useState } from "react";
import SelectMenu from "../../../controls/SelectMenu";
import {
  convertToDefEventPara,
  productionStatusOptions,
} from "../../../../shared/utility";

export default function ManufacturingRecipeSelect(props) {
  const {
    isEdit,
    manufacturedProduct,
    onFetchRecipeItems,
    recipes,
    handleInputChange,
    values,
  } = props;

  const [chosenRecipe, setChosenRecipe] = useState(null);

  useEffect(() => {
    if (manufacturedProduct?.selectedRecipe?.recipe) {
      const recipe = recipes.find(
        (el) => el.value === manufacturedProduct.selectedRecipe.recipe.id,
      );
      setChosenRecipe(recipe ?? null);
    }
  }, [manufacturedProduct, recipes]);

  return (
    <div className="p-4 card-custom">
      <div className="grid grid-cols-1 gap-2">
        <div className="col-span-1">
          <SelectMenu
            handleInputChange={(e) => {
              onFetchRecipeItems(e.target.value.value, values.new_weight);
              setChosenRecipe(e.target.value);
            }}
            name="selected_recipe"
            options={recipes}
            value={chosenRecipe}
            title={"Recipe"}
          />
        </div>
        <div className="col-span-1">
          <SelectMenu
            name="status"
            handleInputChange={(e) => {
              handleInputChange(
                convertToDefEventPara("status", e.target.value),
              );
            }}
            options={productionStatusOptions}
            value={values.status}
            title={"Status"}
          />
        </div>
      </div>
    </div>
  );
}
